// Pure shared primitives — no JSON, no ECS, no third-party imports. The invariant-error class lives here
// (moved from @taxwar/net) so the Node data tool can raise the same typed error the sim does without pulling
// in the net package. packages/net/src/errors.ts re-exports this exact class, preserving constructor identity.

/** A programmer error inside sim, hosts or schema: the match must abort (docs/ARCHITECTURE.md §13). */
export class InvariantViolation extends Error {
  override readonly name = 'InvariantViolation'
}
